import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainReplaceAccessControlDevice(beforeId, afterId) {
  return maintainRequest.post(
    `/device/maintenanceMan/accessDevice/replaceAccessControlDevice/${beforeId}/${afterId}`
  );
}
